import { DoqFace, DoqType, getDashboardDoqSize } from '@ardoq/doq';
import { DoqyWithMessage } from './DoqyWithMessage';
import { DashboardModes } from '../../types';
import { type I18nLocale, t } from '@ardoq/i18n';
import { TextOverflow } from '@ardoq/popovers';

const NoDataDoqy = ({
  dashboardMode,
  i18nLocale,
}: {
  dashboardMode: DashboardModes;
  i18nLocale: I18nLocale;
}) => {
  const message =
    dashboardMode === DashboardModes.VIEW ||
    dashboardMode === DashboardModes.EDIT
      ? t(
          i18nLocale,
          'dashboard:noDataDoqy.viewMessage',
          'No data to show. The underlying query found no results.'
        )
      : t(
          i18nLocale,
          'dashboard:noDataDoqy.metricsMessage',
          "There isn't enough data to display here. This will be updated as Ardoq gets used more often within your organization(s)."
        );

  return (
    <DoqyWithMessage>
      <DoqFace
        doqType={DoqType.DASHBOARD_BELLY_MISSING_ORG}
        doqSize={getDashboardDoqSize()}
      />
      <TextOverflow lineClamp={2}>{message}</TextOverflow>
    </DoqyWithMessage>
  );
};

export { NoDataDoqy };
